module.exports = __webpack_public_path__ + "static/media/contact-3.c137cef6.jpg";